import { type CSSProperties } from 'react';
import { Icon } from '@components/icon/Icon';
import { parseToDayMonthFormat } from '@shared/utils/dateFormatters';
import { getRestaurantImagePath } from '@shared/utils/getRestaurantImagePath';
import { ISOTimeTo12HourTime } from '@shared/utils/time';
import { useRestaurantContext } from 'webReservations/context/RestaurantContext';
import typography from '~styles/typography.scss';
import styles from './RestaurantEventCheckout.scss';
import { RestaurantEvent } from '@shared/types/restaurants';

interface RestaurantEventCheckoutProps {
  date: string;
  time: string;
  guestCount: number;
  restaurantEvent: RestaurantEvent;
  tableName?: string;
}

export const RestaurantEventCheckout = ({
  date,
  time,
  guestCount,
  tableName,
  restaurantEvent,
}: RestaurantEventCheckoutProps) => {
  const { restaurantDetails } = useRestaurantContext();

  const eventImage = restaurantEvent.images[0] || null;

  return (
    <section className={styles.event}>
      <div className={styles.img}>
        <img
          src={`${process.env.RESTAURANT_IMAGE_BASE_URL}/${restaurantDetails.id}/main.jpg`}
          alt="Restaurant"
        />
        <div />
      </div>
      <div className={styles.location}>
        <h6 className={typography.h7}>{restaurantDetails.name}</h6>
        <div className={styles.row}>
          <Icon name="locationArrow" className={styles.iconArrow} />
          <p className={typography.t2}>{restaurantDetails.address}</p>
        </div>
        <div className={styles.gridInfo}>
          <div className={styles.tile}>
            <Icon name="calendar" className={styles.icon} />
            <p className={typography.t2}>{parseToDayMonthFormat(date)}</p>
          </div>
          <div className={styles.tile}>
            <Icon name="clock" className={styles.icon} />
            <p className={typography.t2}>{ISOTimeTo12HourTime(time)}</p>
          </div>
          <div className={styles.tile}>
            <Icon name="couple" className={styles.icon} />
            <p className={typography.t2}>{guestCount}</p>
          </div>
          {tableName && (
            <div className={styles.tile}>
              <Icon name="table" className={styles.icon} />
              <p className={typography.t2}>{tableName}</p>
            </div>
          )}
        </div>
      </div>
      <div
        className={styles.eventTile}
        style={
          eventImage
            ? ({
                '--background-image': `url(${getRestaurantImagePath(eventImage.imageKey)})`,
              } as CSSProperties)
            : undefined
        }
      >
        <h6 className={typography.h7}>{restaurantEvent.name}</h6>
        <p className={typography.t2}>{restaurantEvent.description}</p>
      </div>
    </section>
  );
};
